import i18n from 'i18next';

export enum FieldComponentTypeEnum {
  Dropdown = '001',
  DependentField = '002',
  MultiSelect = '003',
  Text = '004',
  MultiLineText = '005',
  Numeric = '006',
  Decimal = '007',
  Checkbox = '008',
  Date = '009',
  TagsInput = '010',
}

export enum FieldComponentIconEnum {
  '001' = 'arrow_drop_down',
  '002' = 'panel_open',
  '003' = 'done_all',
  '004' = 'format_size',
  '005' = 'notes',
  '006' = 'metric',
  '007' = 'compare_arrows',
  '008' = 'check',
  '009' = 'calendar_today',
  '010' = 'local_offer',
}

export class FieldComponentTypeClass {
  private static _instance: FieldComponentTypeClass;

  [FieldComponentTypeEnum.Dropdown] = i18n.t('drop_down', { ns: 'metadata' });
  [FieldComponentTypeEnum.DependentField] = i18n.t('dependent_field', { ns: 'metadata' });
  [FieldComponentTypeEnum.MultiSelect] = i18n.t('multi_select', { ns: 'metadata' });
  [FieldComponentTypeEnum.Text] = i18n.t('text', { ns: 'metadata' });
  [FieldComponentTypeEnum.MultiLineText] = i18n.t('multi_line_text', { ns: 'metadata' });
  [FieldComponentTypeEnum.Numeric] = i18n.t('numeric', { ns: 'metadata' });
  [FieldComponentTypeEnum.Decimal] = i18n.t('decimal', { ns: 'metadata' });
  [FieldComponentTypeEnum.Checkbox] = i18n.t('checkbox', { ns: 'metadata' });
  [FieldComponentTypeEnum.Date] = i18n.t('date', { ns: 'metadata' });
  [FieldComponentTypeEnum.TagsInput] = i18n.t('tags_input', { ns: 'metadata' });

  static getInstance() {
    if (!this._instance) {
      this._instance = new FieldComponentTypeClass();
    }
    return this._instance;
  }
}
